import type { ReactNode } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import './toast.css'

export interface ToastProviderProps {
  children: ReactNode
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <div className="glasspro-toast">
      {children}
      <ToastContainer closeOnClick stacked />
    </div>
  )
}
